import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'gestiongruposreservas',
  templateUrl: 'gestiongruposreservas.html'
})
export class GestiongruposreservasComponent {


  @Input() listaGruposProductos = []
  @Output() productoFiltrado = new EventEmitter<any>();

  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  filtrogruposProductosId
  tipo:string = ""
  constructor() {
  }

  filtrarProductos(item) {
    this.filtroGruposActivo = true
    this.productoFiltrado.emit({ filtroGruposActivo: this.filtroGruposActivo, nombreFiltroGrupo: item.nombre});
  }

}



// WEBPACK FOOTER //
// ./src/components/gestiongruposreservas/gestiongruposreservas.ts